module.exports = __webpack_public_path__ + "img/dreammachine-pc.97cdc8df.png";